import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { hideScrollbars } from '@picsart/design-system/styleUtils/hideScrollbars';

const useStyles = createUseStyles(
  {
    // Non-scrolling shell: tabs on top, layered tab content below.
    root: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 0,
    },
    tabContent: {
      position: 'relative',
      flex: 1,
      minHeight: 0,
    },
    // Always-mounted feed layer, hidden with the `hidden` attribute while a tool
    // tab is active. `display: none` empties the intersection rect, so the card
    // videos inside stop decoding on their own; `visibility: hidden` left them
    // playing behind the panel. Scroll position is restored from
    // `savedScrollTopRef` rather than being preserved by the layer. Tool panels
    // render as their own keep-alive layers (see HomeToolLayer).
    feedLayer: {
      position: 'absolute',
      inset: 0,
      // `:not([hidden])` is required — a bare `display` would override the
      // hidden attribute and keep the layer rendered.
      '&:not([hidden])': {
        display: 'flex',
      },
      flexDirection: 'column',
      overflowY: 'auto',
      overflowX: 'hidden',
      overscrollBehavior: 'contain',
      paddingBlock: [Spacings.s8, Spacings.s16],
      ...hideScrollbars,
    },
  },
  { name: 'CategoryRowsHome' }
);

export default useStyles;
